import { RequestServiceCodeConstant, ServiceRequestCodeRequiredFieldList } from "presentation/constant/RequestServiceCode/RequestServiceCodeConstant";
import { useRequestServiceCodeVM } from "presentation/hook/RequestServiceCode/useRequestServiceCodeVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useRequestServiceCodeTracked } from "presentation/store/RequestServiceCode/RequestServiceCodeProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import { useCallback, useMemo, useState } from "react";
import { FieldType, HPHBreadcrumb, HPHCheckbox, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, SidebarCaption, Sidebarheader, SidebarTitle, StyledAction, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const RequestServiceCodeEditPanel = () => {
    const SCREEN_CONSTANT = RequestServiceCodeConstant;
    const [isLoading, setIsLoading] = useState(false);
    const [requestServiceCodeState] = useRequestServiceCodeTracked();
    const requestServiceCodeStateVM = useRequestServiceCodeVM();
    const { currentEditRow, isAdd, isEdit, masterState } = requestServiceCodeState;
    const { isSaveClicked, allFormState } = masterState;
    const messageBarVM = useMessageBarVM();
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;

    const handleSave = useCallback(async () => {
        // if (!currentEditRow.serviceRequestCode) {
        //     messageBarVM.showError("Service Request Code is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.subServiceRequestCode) {
        //     messageBarVM.showError("Sub-Service Request Code is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.activeInd) {
        //     messageBarVM.showError("Active Ind is mandatory.");
        //     return;
        // }
        setIsLoading(true);
        requestServiceCodeStateVM.onSaveClicked();
        await requestServiceCodeStateVM.onSave(currentEditRow).then(data => {
            if (data && data.success) {
                requestServiceCodeStateVM.onSearch().then((data) => {
                    messageBarVM.showSuccess("Save Successfully.");
                    setIsLoading(false)
                }).catch(error => {
                    setIsLoading(false)
                });
            } else {
                setIsLoading(false)
                data.data && messageBarVM.showError(data.data);
                return;
            }
        });
    }, [currentEditRow, messageBarVM, requestServiceCodeStateVM]);

    const handClose = useCallback(() => {
        requestServiceCodeStateVM.onCloseEidtPanel();
    }, [requestServiceCodeStateVM]);


    const memoServiceRequestCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "450px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd)}
                isShowOptional={false}
                readOnlyValue={currentEditRow.serviceRequestCode ?? ""}
                fieldValue={currentEditRow?.serviceRequestCode ?? []}
                fieldLabel={SCREEN_CONSTANT.SERVICE_REQUEST_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'serviceRequestCode'}
                maxLength={50}
                isMultipleDropDown={true}
                requiredFieldList={ServiceRequestCodeRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    requestServiceCodeStateVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SERVICE_REQUEST_CODE, allFormState, currentEditRow.serviceRequestCode, isAdd, isSaveClicked, requestServiceCodeStateVM])

    const memoSubServiceRequestCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "450px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd)}
                isShowOptional={false}
                readOnlyValue={currentEditRow.subServiceRequestCode ?? ""}
                fieldValue={currentEditRow?.subServiceRequestCode ?? []}
                fieldLabel={SCREEN_CONSTANT.SUB_SERVICE_REQUEST_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'subServiceRequestCode'}
                maxLength={50}
                isMultipleDropDown={true}
                requiredFieldList={ServiceRequestCodeRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    requestServiceCodeStateVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SUB_SERVICE_REQUEST_CODE, allFormState, currentEditRow.subServiceRequestCode, isAdd, isSaveClicked, requestServiceCodeStateVM])

    const memoRemark = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "450px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow.remark ?? ""}
                fieldValue={currentEditRow?.remark ?? []}
                fieldLabel={SCREEN_CONSTANT.REMARK}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'remark'}
                maxLength={500}
                isMultipleDropDown={true}
                requiredFieldList={ServiceRequestCodeRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    requestServiceCodeStateVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.REMARK, allFormState, currentEditRow.remark, isAdd, isEdit, isSaveClicked, requestServiceCodeStateVM])




    const memoActiveInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "450px", marginBottom: "24px" }}>
            <NbisCommonField
                fieldKey={"activeInd"}
                requiredFieldList={ServiceRequestCodeRequiredFieldList}
                fieldLabel={SCREEN_CONSTANT.ACTIVE_IND}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                label={""}
                checked={currentEditRow?.activeInd === 'Y'}
                disabled={!(isAdd || isEdit)}
                onChange={(e) => requestServiceCodeStateVM.onCheckboxChange(e.checked, "activeInd")}
            />
        </div>
        , [SCREEN_CONSTANT.ACTIVE_IND, currentEditRow?.activeInd, isAdd, isEdit, requestServiceCodeStateVM])

    const handleEdit = useCallback(() => {
        requestServiceCodeStateVM.onEditClick();
    }, [requestServiceCodeStateVM]);

    const handleReset = useCallback(() => {
        requestServiceCodeStateVM.onResetClick(isAdd);
    }, [requestServiceCodeStateVM, isAdd]);

    return <>
        <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
            <Sidebarheader style={{ width: '100%' }}>
                {isLoading && <Loader Indicator="Spinner" size="Medium" />}
                <Breadcrumb>
                    <HPHBreadcrumb breadcrumbData={[{ title: SCREEN_CONSTANT.CATEGORY },
                    { title: SCREEN_CONSTANT.TITLE }]} onCurrentClick={() => { }}>
                    </HPHBreadcrumb>
                </Breadcrumb>
                <StyledAction>
                    <>
                        {allowUpdate && (!(isAdd || isEdit)) && <NbisIconButton fileName='Icon-pen' size='medium' disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Edit'} onClick={handleEdit} />}
                        {(isAdd || isEdit) && <IconButton fileName="Icon-reset" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={() => handleReset()} />}

                        <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                        {(isAdd || isEdit) && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />}
                    </>
                </StyledAction>
            </Sidebarheader>

            <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <div className={'im-flex-row'}>
                            <div className={'flex-row-item-stretch'}>
                                <SidebarTitle>
                                    {isAdd && "New Request Service Code"}
                                    {!isAdd && (currentEditRow.serviceRequestCode)}
                                </SidebarTitle>
                                {<SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                            </div>
                        </div>

                        <CriteriaItemContainer>
                            {memoServiceRequestCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoSubServiceRequestCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoRemark}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoActiveInd}
                        </CriteriaItemContainer>

                    </div>
                </div>
            </div>
        </StyledSidebar>
    </>
}

export default RequestServiceCodeEditPanel;
